var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { gql } from '@apollo/client';
export var GET_MAGENTO_EXTENSION_CONTEXT = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query magentoExtensionContext {\n    magentoExtensionContext: dataServicesMagentoExtensionContext {\n      magento_extension_version\n    }\n  }\n"])));
export default {
  getMagentoExtensionContext: GET_MAGENTO_EXTENSION_CONTEXT
};